export default function findDisclaimerKey (fields) {
	return fields.reduce((accumulator, item) => {
		const found = (item.admin_label === 'readDisclaimer')
			|| (item.key.match(/^i_have_read_the_disclaimer/));
		if (found) {
			return item.key;
		}
		return accumulator;
	}, false);
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/forms/ai-enhanced-form-fields/source-form-locators/findDisclaimerKey.js